"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.GlobalComponentsProvider = exports.useGlobalComponents = exports.GlobalComponentsContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _GlobalErrorHandler = _interopRequireDefault(require("./GlobalErrorHandler"));

var GlobalComponentsContext = /*#__PURE__*/(0, _react.createContext)({
  ErrorHandler: _GlobalErrorHandler.default,
  RouterLayout: _react.Fragment
});
exports.GlobalComponentsContext = GlobalComponentsContext;

var useGlobalComponents = function useGlobalComponents() {
  return (0, _react.useContext)(GlobalComponentsContext);
};

exports.useGlobalComponents = useGlobalComponents;

var GlobalComponentsProvider = function GlobalComponentsProvider(_ref) {
  var components = _ref.components,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(GlobalComponentsContext.Provider, {
    value: components
  }, children);
};

exports.GlobalComponentsProvider = GlobalComponentsProvider;
GlobalComponentsProvider.propTypes = {
  components: _propTypes.default.object,
  children: _propTypes.default.node
};